<template>
  <div class="tx-products module-filter-level1" :class="{'-open': opened}">
    <div class="level1__label" @click="changeOpened()"><span>{{ level1.label }}</span></div>
    <div class="form level1__categories-wrapper">
      <div class="level1__categories-close icon-close-x-after" @click="$emit('closeDropdown')"></div>
      <div class="form-group" v-for="(level2, index) in level1.options" :key="'level2-' + index">
        <div class="checkbox" :class="{ '-checked': filterCategories.filter(selected => selected.categoryId === level2.categoryId).length }">
          <label class="form-check-label">
            <input type="checkbox" :id="level2.label" :value="{label : level2.label, categoryId: level2.categoryId, parent: level1 }" v-model="value">
            <span>{{ level2.label }}</span>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { mapState } from 'vuex'

export default {
  name: 'Level1Filter',
  // inject: ['mobile'],
  props: {
    level1: {
      type: Object,
      default: () => {
      }
    },
    opened: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState({
      categories: state => state.filter.categories,
      filterCategories: state => state.filter.filterCategories
    }),
    value: {
      get () {
        return this.filterCategories
      },
      set (value) {
        this.$store.commit('filter/setFilterCategories', value)
      }
    }
  },
  methods: {
    changeOpened () {
      if (!(window.innerWidth < 1024)) {
        if (this.opened) {
          this.$emit('closeDropdown')
        } else {
          this.$emit('openDropdown')
        }
      }
    }
  }
}
</script>
